export function setConversationsData(conversations = []) {
  return {
		type: "FETCH_USER_CONVERSATIONS",
		conversations: conversations
  }
}